<script>
    /**
     * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
     * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
     *
     * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
     */
    let { attributes = {} } = $props();
</script>

<!-- eslint-disable-next-line svelte/no-at-html-tags -->
<div class="rubric-block">{@html attributes.body}</div>
